import { Button } from '@shared/components/ui/button';
// import { SortConfig } from '@components/ui/VirtualTable'; // Ya no se usa
import { EMPTY_VIEW_ICONS, EmptyView } from '@shared/components/ui/EmptyView';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Cart } from '../../models/Cart';
import { CartCardList, CartAgGridTable } from '../display';

interface CartsViewProps {
  carts: Cart[];
  error: unknown;
  onCartEdit: (cart: Cart) => void;
  onCartDelete: (cart: Cart) => void;
  onCartAdjust: (cart: Cart) => void;
  onCartPrint: (cart: Cart, size: 'small' | 'large') => void;
  onCartToggleLock: (cart: Cart) => void;
  onCartViewProducts: (cart: Cart) => void;
  fetchNextPage: () => void;
  hasNextPage: boolean | undefined;
  isFetchingNextPage: boolean;
  sorting: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange: (newSorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
  total: number;
  isLoading: boolean;
  isFetching: boolean;
  hasActiveFilters: boolean;
  hasSearchTerm: boolean;
  onCreateCart: () => void;
}

const CartsView: React.FC<CartsViewProps> = ({
  carts,
  error,
  onCartEdit,
  onCartDelete,
  onCartAdjust,
  onCartPrint,
  onCartToggleLock,
  onCartViewProducts,
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  sorting,
  onSortingChange,
  total,
  isLoading,
  isFetching,
  hasActiveFilters,
  hasSearchTerm,
  onCreateCart,
}) => {
  const { t } = useTranslation('cartsModule');

  if (error) {
    return null;
  }

  // No renderizar tabla ni EmptyView mientras está cargando
  if (isLoading) {
    return null;
  }

  const hasNoResults = hasSearchTerm || hasActiveFilters;
  const shouldShowEmptyView = carts.length === 0;

  if (shouldShowEmptyView) {
    return (
      <EmptyView
        type={hasNoResults ? 'noResults' : 'emptyState'}
        icon={EMPTY_VIEW_ICONS.MERCHANDISE}
        customAction={
          hasNoResults ? null : (
            <Button
              onClick={onCreateCart}
              variant="primary"
              size="default"
              className="transition-colors mx-auto w-full md:w-auto"
              data-testid="empty-state-create-cart-button"
            >
              {t('button.create')}
            </Button>
          )
        }
      />
    );
  }

  const cartViewProps = {
    carts,
    onCartEdit,
    onCartDelete,
    onCartAdjust,
    onCartPrint,
    onCartToggleLock,
    onCartViewProducts,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    sorting,
    onSortingChange,
    total,
  };

  const renderCartView = () => {
    if (isMobile) {
      return <CartCardList {...cartViewProps} showActions={true} />;
    }

    // 🎯 Usar CartAgGridTable en lugar de CartTable
    return <CartAgGridTable {...cartViewProps} isFetching={isFetching} />;
  };

  return <div className="mb-4">{renderCartView()}</div>;
};

export default CartsView;
